import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class CombinationsMinExposureValidator extends BaseValidator {
    private errorMessage: string = 'Your total MIN EXP for combinations exceeds the 100% limit.';
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;

        if (stacking.getTotalMinExposureOfCheckedStackCombinations() > 100) {
            this.addError(this.errorMessage);
            return;
        }
    }
}

export default CombinationsMinExposureValidator;
